import {Stack, styled, Box} from '@mui/material';

import {CTAButtonFixed} from 'presentation/components';

export const Wrapper = styled(Stack)`
	width: 100%;
	border-radius: 0px;
	padding: 16px;
	gap: 16px;
	background-color: ${({ theme }) => theme.palette.background.paper};

	${({ theme }) => theme.breakpoints.up('sm')} {
		border-radius: 8px;
	}
`;

export const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
`;

export const StyledForm = styled('form')`
	display: flex;
	flex-direction: column;
	padding: 0px;
	gap: 16px;
	width: 100%;
	flex: 1;

	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: 24px 32px 32px;
		margin-inline: auto;
		max-width: 852px;
	}
`;

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({ theme }) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export const OptionsGrid = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '301px 301px',
	gap: 16,
	justifyContent: 'center',
	[theme.breakpoints.down('sm')]: {
		gridTemplateColumns: '1fr',
	},
}));

export const StyledOptionCard = styled('div')`
	background-color: ${({ theme }) => theme.palette.background.paper};
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 16px 16px 24px;
	cursor: pointer;
	width: 100%;
	height: 68px;

	${({ theme }) => theme.breakpoints.up('sm')} {
		width: 301px;
	}
`;

